import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/components/layout'
// 获取原型对象push函数
const originalPush = Router.prototype.push
// 获取原型对象replace函数
const originalReplace = Router.prototype.replace
// 修改原型对象中的push函数
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// 修改原型对象中的replace函数
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

// 公共路由
export const constantRoutes = [{
    path: '/404',
    name: '404',
    component: () => import('@/pages/error/404'),
    hidden: true
  },
  {
    path: '/401',
    name: '401',
    component: () => import('@/pages/error/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [{
        path: 'home',
        component: () => import('@/pages/homePage'),
        name: 'home',
        meta: {
          title: '首页'
        }
      },
      {
        path: 'person',
        component: () => import('@/pages/personItem/navBar'),
        name: 'person',
        meta: {
          title: '人大概况'
        }
      },
      {
        path: 'personNews',
        component: () => import('@/pages/personNews/list'),
        name: 'personNews',
        meta: {
          title: '人大新闻'
        }
      },
      {
        path: 'Supervision',
        component: () => import('@/pages/Supervision/list'),
        name: 'Supervision',
        meta: {
          title: '监督工作'
        }
      },
      {
        path: 'RepresentativeWork',
        component: () => import('@/pages/RepresentativeWork/list'),
        name: 'RepresentativeWork',
        meta: {
          title: '代表工作'
        }
      },
      {
        path: 'personTownStreet',
        component: () => import('@/pages/personTownStreet/list'),
        name: 'personTownStreet',
        meta: {
          title: '镇街人大'
        }
      },
      {
        path: 'partyConstruction',
        component: () => import('@/pages/partyConstruction/list'),
        name: 'partyConstruction',
        meta: {
          title: '党建工作'
        }
      },
      {
        path: 'personNationalCongress',
        component: () => import('@/pages/personNationalCongress/list'),
        name: 'personNationalCongress',
        meta: {
          title: '人大工作'
        }
      },
      {
        path: 'meetingMaterials',
        component: () => import('@/pages/meetingMaterials/list'),
        name: 'meetingMaterials',
        meta: {
          title: '会议资料'
        }
      },
      {
        path: 'academyEngineering',
        component: () => import('@/pages/academyEngineering/list'),
        name: 'academyEngineering',
        meta: {
          title: '一府一委两院'
        }
      },
      {
        path: 'law',
        component: () => import('@/pages/law/list'),
        name: 'law',
        meta: {
          title: '相关法律'
        }
      },
      {
        path: 'detail',
        component: () => import('@/pages/detail'),
        name: 'detail',
        meta: {
          title: '详情'
        }
      },
      {
        path: 'search',
        component: () => import('@/pages/search'),
        name: 'search',
        meta: {
          title: '搜索'
        }
      },
    ]
  },


]

export default new Router({
  mode: 'history', // 去掉url中的#
  routes: constantRoutes
})